module.exports = __webpack_public_path__ + "static/media/ic_medal_gold.84150c7c.png";